import { render, staticRenderFns } from "./request-offer.vue?vue&type=template&id=fb4b30a8&scoped=true"
import script from "./request-offer.vue?vue&type=script&lang=js"
export * from "./request-offer.vue?vue&type=script&lang=js"
import style0 from "./request-offer.vue?vue&type=style&index=0&id=fb4b30a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4b30a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,Card: require('/var/www/tubber-new/components/global/Card.vue').default})
